import { render } from "./TeamManageRegistView.vue?vue&type=template&id=3dd81264"
import script from "./TeamManageRegistView.vue?vue&type=script&lang=js"
export * from "./TeamManageRegistView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__